export default "__VITE_ASSET__DYnGt5Kc__"